import React, { Component } from 'react';
import styled from 'styled-components';
import { SingleDatePicker } from 'react-dates';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import moment from 'moment';
import Tooltip from '../Tooltip';
import Icon from '../Icon';
import get from 'lodash/get';
import { connect } from 'react-redux';

const DatePickerContainer = styled.div`
  width: 100%;

  .DateInput,
  .DateInput_input {
    margin-left: 20px;
    height: 45px;
  }

  .SingleDatePickerInput {
    width: 100%;

    font-size: 14px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .SingleDatePicker {
    width: 100%;
  }

  .DateInput_input {
    margin: 0;
    padding: 0;
    border-bottom: 0;
    font-size: 12px;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
  }

  .SingleDatePicker_picker {
    top: 45px !important;
  }

  .SingleDatePickerInput_calendarIcon {
    padding: 0;
    margin: 0 3px 0 auto;
  }

  .DateInput svg {
    left: 210px;
    top: 35px;
  }

  .CalendarMonth,
  .DayPicker_transitionContainer,
  .CalendarDay,
  .SingleDatePicker_picker,
  .CalendarMonthGrid,
  .DayPicker {
    background-color: #fbfcfc;
  }

  .DayPicker_transitionContainer {
    height: 295px !important;
  }

  .DayPicker_weekHeader {
    height: 22px;
    top: 75px !important;

    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 13px;
    letter-spacing: 0.2px;
    color: #c8c9cc;
  }

  .DayPicker_weekHeader_ul {
    font-size: 11px;
    border-bottom: 1px solid #c8c9cc;
    height: 100%;
  }

  .CalendarDay__selected {
    background-color: #ecedf1;
    color: black;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-weight: 600;
  }

  .CalendarMonth_caption {
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 14px;
    color: black;
    padding-top: 32px;
    padding-bottom: 40px;
    letter-spacing: 0.2px;
  }

  .CalendarDay__default {
    border: 0;
    font-size: 11px;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-weight: 600;
    border-radius: 50%;
    line-height: 30px;
    vertical-align: center;
  }

  .CalendarDay__default:hover {
    background-color: #ecedf1;
    border: 0;
  }

  .CalendarMonth_table {
    margin-top: 20px;
    border-collapse: initial;
    border-spacing: 0px 5px !important;
  }

  .CalendarDay__outside {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-weight: 600;
    color: #e1e1e1;
  }

  .CalendarDay__blocked_out_of_range {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-weight: 600;
    color: #e1e1e1;
  }

  .eventContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  .dotEvent {
    border-radius: 50%;
    min-width: 4px;
    min-height: 4px;
    height: 4px;
    width: 4px;
    position: absolute;
    top: 3px;
    right: 3px;
    background-color: ${(props) => props.theme.colors['terra-cotta']};
  }

  .label {
    font-size: 12px;
    font-family: ${(props) => props.theme.fonts.oswald};
    text-transform: uppercase;
    color: ${(props) => props.theme.colors.dark};
    margin-bottom: 7px;
  }

  .labelContainer {
    display: flex;
    flex-direction: row;
  }

  .labelContainer > div {
    margin-left: 4px;
  }

  .tooltipContainer {
    width: 12px;
  }

  ${(props) => props.styles}
`;

const renderDayContents = (date, eventDates) => {
  if (eventDates && eventDates.includes(moment(date).format('DD/MM/YYYY'))) {
    return (
      <div className="eventContainer">
        {moment(date).format('D')}
        <div className="dotEvent" />
      </div>
    );
  } else {
    return moment(date).format('D');
  }
};

class DatePicker extends Component {
  render() {
    const {
      date,
      onChange,
      focused,
      onFocusChange,
      eventDates,
      styles,
      label,
      tooltip,
      lang,
      ...otherProps
    } = this.props;

    return (
      <DatePickerContainer styles={styles}>
        {label && (
          <div className="labelContainer">
            <p className="label">{label}</p>
            {tooltip && (
              <div className="tooltipContainer">
                <Tooltip {...tooltip} />
              </div>
            )}
          </div>
        )}
        <SingleDatePicker
          enableOutsideDays
          isOutsideRange={() => false}
          date={date}
          renderDayContents={(props) => renderDayContents(props._d, eventDates)}
          renderMonthElement={({ month }) =>
            moment(month).locale(lang).format('MMMM')
          }
          placeholder={moment().format('DD/MM/YYYY')}
          showDefaultInputIcon
          inputIconPosition="after"
          onDateChange={(date) => onChange(date)}
          verticalSpacing={15}
          numberOfMonths={1}
          daySize={31}
          keepOpenOnDateSelect={false}
          navPrev={
            <div
              style={{
                display: 'inline-flex',

                padding: 5,
                fontSize: 6,
                position: 'absolute',
                top: '31px',
                left: '50px'
              }}
            >
              <Icon icon="chevronLeft" />
            </div>
          }
          firstDayOfWeek={1}
          hideKeyboardShortcutsPanel
          navNext={
            <div
              style={{
                padding: 5,
                fontSize: 6,
                display: 'inline-flex',
                position: 'absolute',
                top: '31.5px',
                left: '195px'
              }}
            >
              <Icon icon="chevronRight" />
            </div>
          }
          focused={focused}
          onFocusChange={({ focused }) => onFocusChange(focused)}
          displayFormat={'DD/MM/YYYY'}
          id={get(this.props, 'id', 'datePickerId')}
          {...otherProps}
        />
      </DatePickerContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: get(state, 'i18n.locale')
  };
};

export default connect(mapStateToProps, [])(DatePicker);
